import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

const CommunityIdentificationCodeTypesService = ComposedComponent =>
  reduxFetch([
    {
      resource: 'communityIdentificationCodeTypes',
      method: 'get',
      request: id => ({
        url: apiRoutes.communityIdentificationCodeTypes(id),
      }),
    },
  ])(ComposedComponent);

export default CommunityIdentificationCodeTypesService;
